// extracted by css-extract-rspack-plugin
module.exports =  {"modal-support-form":"SupportMessage-iCyz__modal-support-form","message":"SupportMessage-Yo0D__message"};